// Name and email in a table cell, shared by the AI Assistant and MCP history tables
export default {
    name: 'UserCell',
    functional: true,
    props: { name: String, email: String, none: Boolean },
    render(h, { props }) {
        if (props.none || !props.name) {
            return h('span', { class: 'grey--text' }, 'System / unknown')
        }
        return h('div', { style: 'line-height:1.25' }, [
            h('div', { class: 'body-2' }, props.name),
            h('div', { class: 'caption grey--text' }, props.email),
        ])
    },
}
